export const CONTRAST_AMOUNT = 1.1;
export const BRIGHTNESS_BOOST = 1;
export const BRIGHTNESS_ADD = 0.1;

export const DEFAULT_DAY_IMAGE_URL = "https://res.cloudinary.com/lesswrong-2-0/image/upload/v1762666472/flat_earth_Largest_still3_yltj4n_otlubi.jpg";
export const DEFAULT_NIGHT_IMAGE_URL = "https://res.cloudinary.com/lesswrong-2-0/image/upload/v1762666463/nightearth_lkrdgh.jpg";
export const DEFAULT_LUMINOSITY_IMAGE_URL = "https://res.cloudinary.com/lesswrong-2-0/image/upload/v1762666542/luminositymap_rrwlcl.jpg";
export const DEFAULT_ALTITUDE_SCALE = 0.099;
export const DEFAULT_INITIAL_ALTITUDE_MULTIPLIER = 1;
// Sun position in lat/lng coordinates (degrees)
export const DEFAULT_SUN_POSITION = { lat: 0, lng: 30 };

